import { createSlice } from "@reduxjs/toolkit";

const suppliersState = {
  suppliers: [],
  suppliersLoading: false,
  supplierDetails: null,
  supplierDetailsLoading: false,

  submitPortalAccessLoading: false,
  submitPortalAccessError: false,
};

const reducers = {
  setSuppliers(state, action) {
    state.suppliers = action.payload;
  },
  setSuppliersLoading(state, action) {
    state.suppliersLoading = action.payload;
  },
  setSupplierDetails(state, action) {
    state.supplierDetails = action.payload;
  },
  setSupplierDetailsLoading(state, action) {
    state.supplierDetailsLoading = action.payload;
  },
  setSubmitPortalAccessLoading(state, action) {
    state.submitPortalAccessLoading = action.payload;
  },
  setSubmitPortalAccessError(state, action) {
    state.submitPortalAccessError = action.payload;
  },
};

export const slice = createSlice({
  name: "suppliers",
  initialState: suppliersState,
  reducers,
});

export const { reducer } = slice;
